<template>
    <div class="row">
        <div class="col-6 mx-auto">
            <newsroom-item-editor-wrapper
                :title="resource('Newsroom_Create_Header')"
            >
                <template v-slot:action-buttons="{ isValid, newsroomItem }">
                    <button :class="{ 'disabled': !isValid }"
                            class="btn btn-primary navbar-btn"
                            @click="submit(isValid, newsroomItem)"
                    >{{resource('Newsroom_Create_Submit_Btn')}}</button>
                </template>
            </newsroom-item-editor-wrapper>
        </div>
    </div>
</template>

<script>
    import api from './../api';
    import { bootstrapDangerGrowl as errorGrowl, bootstrapSuccessGrowl as successGrowl } from "../../../Util/growler";
    import loader from '../../../Util/loader';

    import resourceMixin from "../../../Util/Mixins/resources";

    import NewsroomItemEditorWrapper from "./Editor/NewsroomItemEditorWrapper.vue";

    export default {
        name: 'newsroom-create',
        components: {
            NewsroomItemEditorWrapper
        },
        mixins: [resourceMixin],
        methods: {
            submit(isValid, newsroomItem){
                if(!isValid) return;
                
                const vm = this;

                loader.show();

                api.createNewsroomItem(newsroomItem).then(() => {
                        loader.hide();

                        successGrowl(vm.resource('Newsroom_Create_Success_Message'));
                        vm.$router.push('/Newsroom/');
                    },
                    err => {
                        loader.hide();

                        errorGrowl(err)
                    });
            }
        }
    }
</script>